import React from 'react';

const getImage = (productSlug, images) => {
  switch (productSlug) {
    case 'adjustable-smt-stencil-fixture':
      return images[0].small_url;
    case 'sd300-manual-smt-stencil-printer':
      return images[0].small_url;
    default:
      return images[0].small_url;
  }
};

const ProductImage = (props) => {
  const { productName, productSlug, product_url, images } = props;

  return (
    <div className='d-flex justify-content-center product-image'>
      <a href={product_url} target='_blank' rel="noreferrer">
        <img src={getImage(productSlug, images)} alt={productName} />
      </a>
    </div>
  );
};

export default ProductImage;
